module.exports = __webpack_public_path__ + "img/02.c8b77d60.jpg";